import { render, staticRenderFns } from "./ocrRecognition.vue?vue&type=template&id=f61e0b4c&scoped=true&"
import script from "./ocrRecognition.vue?vue&type=script&lang=js&"
export * from "./ocrRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61e0b4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f61e0b4c')) {
      api.createRecord('f61e0b4c', component.options)
    } else {
      api.reload('f61e0b4c', component.options)
    }
    module.hot.accept("./ocrRecognition.vue?vue&type=template&id=f61e0b4c&scoped=true&", function () {
      api.rerender('f61e0b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocrRecognition.vue"
export default component.exports